import { PROPERTY_TABS } from "../components/property-tabs"
import { useUser } from "../user-context"
import { usePropertyMemberships } from "./use-property-memberships"

/**
 * PROPERTY_TABS filtered for the current viewer. Budget (ZPL-224) is
 * OWNER-ONLY — the API 404s for everyone else, so showing the tab to members
 * would only dead-end them. While memberships load the tab stays hidden
 * (appearing is less jarring than disappearing).
 */
export function useVisiblePropertyTabs(propertyId: string) {
	const { profile } = useUser()
	const memberships = usePropertyMemberships(propertyId)
	const isOwner =
		memberships.data !== undefined && memberships.data.owner.id === profile?.id
	return PROPERTY_TABS.filter((tab) => tab.key !== "budget" || isOwner)
}
